import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from '@kinomap-dev/ng-ui-lib/elements';
import { LoginService } from './core/auth/login.service';

@Component({
  imports: [RouterOutlet, ToasterComponent],
  selector: 'app-root',
  template: `
    <router-outlet />
    <kin-toaster />
  `,
})
export class AppComponent {
  private readonly loginService: LoginService = inject(LoginService);

  constructor() {
    this.loginService.controlToken();
  }
}
